
import wx from 'weixin-js-sdk'
import config from '@/config/index'
import { getShowDetail } from '@/api/zhigongxiaojia'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import amp from './map.vue' 
import markerIcon from '@/assets/zhigongxiaojia/dingwei.png'
export default {
components: { Swiper, SwiperItem, amp },
data () {
let self = this
return {
baseUrl: config.baseUrl,
id: this.$route.query.id,
show_banner: true,
sourcetype: 1, // 1|职工小家
message: {
homeintroduce: '',
homename: '',
homeaddress: '',
longitude: '',
latitude: '',
homeimgsFile: [],
homearea: ''
},
markers: [],
point: [120, 29]
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
created () {
this.getShowDetailNow()
},
methods: {
getShowDetailNow () {
getShowDetail({
id: this.id,
accountid: this.accountid,
sourcetype: this.sourcetype
}).then(res => {
this.message = res.returnValue
if (res.returnValue.homeimgsFile == '') {
this.show_banner = false
}
this.markers = []
let obj = res.returnValue
let marker = this.amap(obj.longitude, obj.latitude)
let objj = {
id: obj.id,
name: obj.unitname,
content: `<div style="z-index:9999"><img src="${markerIcon}" width="35"></div>`,
marke: marker
}
this.markers.push(objj)
})
},
amap (bd_lng, bd_lat) {
var X_PI = (Math.PI * 3000.0) / 180.0
var x = bd_lng - 0.0065
var y = bd_lat - 0.006
var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
var gg_lng = z * Math.cos(theta)
var gg_lat = z * Math.sin(theta)
return [gg_lng, gg_lat]
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item.filepath)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
}
}
}
